import { FC } from 'react';

import { Box } from '@mantine/core';

import cx from './InlineFilters.MeasurementPlaceholder.module.scss';

const InlineFiltersMeasurementPlaceholder: FC<{ children: React.ReactNode }> = ({ children }) => {
    return <Box className={cx.root}>{children}</Box>;
};

export { InlineFiltersMeasurementPlaceholder };
